import "../App.css"

export function Skills() {

    return <div className="Skills" id="skills">
        <h1>Skills</h1>
        <div>
            <div>
                <img src="html.png" alt="html.png" />
                <div>HTML</div>

            </div>
            <div>
                <img src="css.png" alt="css.png" />
                <div>CSS</div>

            </div>
            <div>
                <img src="js.png" alt="js.png" />
                <div>JavaScript</div>

            </div>
            <div>
                <img src="material.svg" alt="material.png" />
                <div>Material UI</div>
            </div>
            <div>
                <img src="react.png" alt="react.png" />
                <div>React</div>

            </div>
            <div>
                <img src="redux.png" alt="redux.png" />
                <div>Redux</div>

            </div>
            { }

        </div>
        <div>
            <div>
                <img src="Node.svg" alt="Node.svg" />
                <div>Node js</div>

            </div>
            <div>
                <img src="ex.png" alt="ex.png" />
                <div>Express js</div>

            </div>
            <div>
                <img src="mongoose.png" alt="mongoose.png" />
                <div>Mongoose</div>

            </div>
            <div>
                <img src="monngo.svg" alt="monngo.svg" />
                <div>MongoDB</div>

            </div>
            <div>
                <img src="ds.png" alt="ds.png" />
                <div>Data Structures & Algorithms</div>

            </div>
        </div>
    </div>
}